import { Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function Testimonials() {
  return (
    <div className="pt-28">
      {/* Hero Section */}
      <section className="bg-black py-24 relative overflow-hidden">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="absolute inset-0 shimmer-wave"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <span className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4 block">Client Testimonials</span>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            What Our <span className="text-gold">Clients Say</span>
          </h1>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto">
            Trusted by leading organizations across healthcare, retail, and commercial industries nationwide
          </p>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30" data-testid="testimonials-section">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Star className="w-16 h-16 text-gold mx-auto mb-8" />
          <h2 className="text-3xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Client Reviews <span className="text-gold">Coming Soon</span>
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            We're gathering feedback from our valued clients. Check back soon to see what they have to say about working with Williams Diversified.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-4xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Ready to Join Our <span className="text-gold">Satisfied Clients</span>?
          </h2>
          <p className="text-gray-300 text-lg mb-8">
            Experience the Williams Diversified difference on your next commercial construction, government contracting, or facility maintenance project.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="bg-gold text-black px-8 py-4 rounded-lg font-semibold hover:bg-gold/90 transition-colors inline-flex items-center justify-center"
            >
              Contact Us Today
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
            <Link 
              to="/request-quote" 
              className="border-2 border-gold text-gold px-8 py-4 rounded-lg font-semibold hover:bg-gold hover:text-black transition-colors"
            >
              Request a Quote
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Testimonials;
